export const REPORT_DEFINITION_VERSION = 3

export type ReportSourceRef = { catalog: string; schema: string; table: string }
export type ReportSource = ReportSourceRef & { alias: string }
export type ReportFieldRef = { source: string; column: string }

export type ReportOperator =
  | 'equals' | 'notEquals'
  | 'contains' | 'startsWith' | 'endsWith'
  | 'lt' | 'lte' | 'gt' | 'gte' | 'between'
  | 'isTrue' | 'isFalse'
  | 'relativeRange'
  | 'isNull' | 'isNotNull'

export type RelativeUnit = 'hours' | 'days' | 'months'
export type ReportConditionValue = string | number | boolean | null | (string | number)[] | { amount: number; unit: RelativeUnit }

export type ReportOperand = { value: ReportConditionValue } | ReportFieldRef
export type ReportComparison = { left: ReportFieldRef; op: ReportOperator; right?: ReportOperand }
export type ReportConditionGroup = { and: ReportConditionNode[] } | { or: ReportConditionNode[] }
export type ReportConditionNode = ReportConditionGroup | ReportComparison

export type ReportAggregationFunction = 'rowCount' | 'count' | 'sum' | 'avg' | 'min' | 'max'
export type ReportAggregation = { function: ReportAggregationFunction; field?: ReportFieldRef; as?: string }
export type ReportSort = { field: string; direction: 'asc' | 'desc' }
export type TimeBucketUnit = 'hour' | 'day' | 'week' | 'month' | 'quarter' | 'year'
export type ReportColumn = ReportFieldRef & { as?: string }
export type ReportGroup = ReportFieldRef & { bucket?: TimeBucketUnit }
export type ReportOutputColumn = ReportColumn | ReportAggregation
export type ReportMeasureRef = { function: ReportAggregationFunction; field?: ReportFieldRef }
export type ReportHavingComparison = { left: ReportMeasureRef; op: ReportOperator; right?: { value: ReportConditionValue } }
export type ReportHavingGroup = { and: ReportHavingNode[] } | { or: ReportHavingNode[] }
export type ReportHavingNode = ReportHavingGroup | ReportHavingComparison

export type ReportJoinType = 'inner' | 'left' | 'right' | 'full'
export type ReportJoin = { type: ReportJoinType; source: ReportSource; on: ReportConditionGroup }

export type ReportQueryDefinition = {
  from: ReportSource
  joins?: ReportJoin[]
  filter?: ReportConditionGroup
  having?: ReportHavingGroup
  columns: ReportOutputColumn[]
  groupBy?: ReportGroup[]
  sort?: ReportSort[]
  limit?: number
}

export type SqlReportQuery = { text: string }

export type ReportEnvelope =
  | { version: 3; kind: 'structured'; parameters: []; query: ReportQueryDefinition }
  | { version: 3; kind: 'sql'; parameters: []; query: SqlReportQuery }

export function structuredEnvelope(query: ReportQueryDefinition): string {
  return JSON.stringify({ version: REPORT_DEFINITION_VERSION, kind: 'structured', parameters: [], query })
}

export function sqlEnvelope(text: string): string {
  return JSON.stringify({ version: REPORT_DEFINITION_VERSION, kind: 'sql', parameters: [], query: { text } })
}
